export default __webpack_public_path__ + "img/548931048d2dc079d38688ef77623cc9.png";